import Api from '../../config/Api'
import { ConvidadoHistory, GetResponse, ScoreDTO } from '../../models'

export const getByConvidadoId = async (convidadoId: string) => {
    return await Api.get<GetResponse<ConvidadoHistory[]>>(`ConvidadoHistory?Condition=convidadoId=%22${convidadoId}%22&Offset=0&Limit=-1&OrderBy=dataCriacao&SortDesc=false`)
}

export const buscarScore = async (eventoId: string) => {
    return await Api.get<ScoreDTO[]>(`ConvidadoHistory/BuscarScore/${eventoId}`)
}